import { useMemo } from "react";
import { parsePages } from "./useNavigationConfig.helpers";

export const useNavigationConfig = () => {
  return useMemo(() => parsePages(), []);
};
